(function () {
  var observer;

  function placeRatingUnderTitle() {
    var meta = document.querySelector('.product__meta');
    if (!meta) return false;

    var inlineRating = meta.querySelector('.product-title-rating-under .jdgm-prev-badge');
    if (inlineRating) {
      var inlineReviewCount = Number(inlineRating.dataset?.numberOfReviews || 0);
      var duplicateBadges = Array.from(meta.querySelectorAll('.shopify-app-block .jdgm-preview-badge'));

      duplicateBadges.forEach(function (badge) {
        var duplicateBlock = badge.closest('.shopify-app-block') || badge;
        duplicateBlock.hidden = true;
      });

      if (inlineReviewCount < 1) {
        inlineRating.closest('.product-title-rating-under').hidden = true;
      }
      return true;
    }

    if (meta.querySelector('.product-title-rating-under')) return true;

    var title = Array.from(meta.querySelectorAll('h1')).find(function (heading) {
      return heading.classList.contains('product__title');
    });
    var badge = meta.querySelector('.jdgm-preview-badge');
    if (!title || !badge) return false;

    var reviewCount = Number((badge.querySelector('.jdgm-prev-badge') || {}).dataset?.numberOfReviews || 0);
    var badgeBlock = badge.closest('.shopify-app-block') || badge;
    if (reviewCount < 1) {
      badgeBlock.hidden = true;
      return true;
    }

    var rating = document.createElement('div');
    rating.className = 'product-title-rating-under';
    var titleGroup = title.closest('.product__title-group') || title;
    titleGroup.parentNode.insertBefore(rating, titleGroup.nextSibling);
    rating.appendChild(badgeBlock);
    return true;
  }

  function addGenuineReviewQuote() {
    var target = document.querySelector('[data-review-quote]');
    if (!target || !target.hidden) return true;

    var widget = document.querySelector('.jdgm-review-widget');
    if (!widget) return false;

    var body = widget.querySelector('.jm-review-content__body, .jdgm-rev__body');
    if (!body || !body.textContent.trim()) return false;

    var reviewItem = body.closest('.jm-review-item__content, .jdgm-rev');
    var author = reviewItem && reviewItem.querySelector('.jm-reviewer-info__name, .jdgm-rev__author');
    var rating = reviewItem && reviewItem.querySelector('[aria-label*="out of 5 stars"]');
    var ratingNumber = rating ? parseInt(rating.getAttribute('aria-label'), 10) : 5;

    target.querySelector('[data-review-stars]').textContent = '★'.repeat(ratingNumber || 5);
    target.querySelector('[data-review-body]').textContent = '“' + body.textContent.trim() + '”';
    target.querySelector('[data-review-author]').textContent = '— ' + (author ? author.textContent.trim() : 'Customer review');
    target.hidden = false;
    return true;
  }

  function enhanceSocialProof() {
    var titleReady = placeRatingUnderTitle();
    var quoteReady = addGenuineReviewQuote();
    if (titleReady && quoteReady && observer) observer.disconnect();
  }

  function initialize() {
    enhanceSocialProof();
    observer = new MutationObserver(enhanceSocialProof);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      if (observer) observer.disconnect();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
